import { Layout, Menu } from 'antd';
import PropType from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { routePaths } from 'routes/route-paths';

const SideBar = ({ sites, brand }) => {
  const { Sider } = Layout;
  const { pathname } = useLocation();

  const findSiteByPathname = useCallback(
    (pathnameValue) => {
      const endpoint = pathnameValue.split('/')[1];

      const foundSite = sites.find(
        (site) =>
          site.path === `/${endpoint}` ||
          site?.subPath?.includes(`/${endpoint}`)
      );

      // Use for redirect from unknown route to main route /
      if (
        !foundSite &&
        !Object.values(routePaths).some((routePath) => {
          return routePath === pathnameValue;
        })
      ) {
        return sites[0];
      }

      return foundSite;
    },
    [sites]
  );

  const defaultSite = findSiteByPathname(pathname);
  const [activeSider, setActiveSider] = useState(defaultSite?.path);

  useEffect(() => {
    const defaultSiteOfHistory = findSiteByPathname(pathname);
    setActiveSider(defaultSiteOfHistory?.path);
  }, [findSiteByPathname, pathname]);

  return (
    <Sider width={236} className="site-layout-background sider">
      <div className="logo-wrapper">
        <img src={brand} alt="logo" className="logo-img" />
      </div>
      {/* TODO: `children` will be removed in next major version. Please use `items` instead. */}
      <Menu
        defaultSelectedKeys={activeSider}
        key={activeSider}
        className="menu-wrapper">
        {sites.map((site) => (
          <Menu.Item key={site.path}>
            <Link
              to={site.path}
              className={`menu-item-anchor ${
                site.filledIcon ? 'has-filled-icon' : ''
              }`}>
              {site.icon} {site.filledIcon && site.filledIcon}
              <span className="menu-item-title">{site.title}</span>
            </Link>
          </Menu.Item>
        ))}
      </Menu>
    </Sider>
  );
};

SideBar.propTypes = {
  sites: PropType.arrayOf(PropType.shape({})).isRequired,
  brand: PropType.string.isRequired
};
export default SideBar;
